/**
 * QUÉ PARTE DEL SEGUIMIENTO VE CADA ROL EN EL PANEL DE INTEGRACIONES (20-oct-2026). PURA.
 *
 * La tarjeta de configuración lee y guarda `bots/{botId}/integrations/config`, y las reglas exigen
 * `canManageIntegrations` para las dos cosas (`firestore.rules`, `match /bots/{botId}/integrations/
 * {integrationId}`). Sin ese permiso la lectura falla, la tarjeta se pintaba con los valores POR
 * DEFECTO y su botón «Guardar» fallaba: un miembro veía «desactivado» en un bot que lo tenía activo.
 * Ahora la tarjeta sólo sale con `canManageIntegrations`; el resumen, con `canViewBots` (su regla), y
 * quien tiene el resumen sin la tarjeta ve una línea que lo explica. Owner por ROL, como el gate de
 * Facturación; fuera de una organización (modo personal) el usuario es el dueño.
 */
export function permisosDelSeguimiento(context) {
  const personal = !context || context.mode !== 'organization';
  const owner = context?.member?.role === 'owner';
  const p = context?.member?.permissions || {};
  const tarjeta = personal || owner || p.canManageIntegrations === true;
  const resumen = personal || owner || p.canViewBots === true;
  return { tarjeta, resumen, aviso: resumen && !tarjeta };
}
